import { render, staticRenderFns } from "./BackTask.vue?vue&type=template&id=13524031&"
import script from "./BackTask.vue?vue&type=script&lang=js&"
export * from "./BackTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports